/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportGenerationFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return ReportGenerationFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<ReportGenerationFeatureFlagsWithDefaults>): ReportGenerationFeatureFlagsWithDefaults {
        let obj = Object.assign(new ReportGenerationFeatureFlagsWithDefaults(), model);
        ReportGenerationFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportGenerationFeatureFlagsWithDefaults>): ReportGenerationFeatureFlagsWithDefaults {
        if (!model) return null;
        return ReportGenerationFeatureFlagsWithDefaults.newInstance(<ReportGenerationFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportGenerationFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.ReportGenerationFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportGenerationFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportGenerationFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    regn_2504_a_test_flag: boolean = false;

}
